import { render, staticRenderFns } from "./NoticeEdit.vue?vue&type=template&id=53f1d787&scoped=true"
import script from "./NoticeEdit.vue?vue&type=script&lang=js"
export * from "./NoticeEdit.vue?vue&type=script&lang=js"
import style0 from "./NoticeEdit.vue?vue&type=style&index=0&id=53f1d787&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f1d787",
  null
  
)

export default component.exports